<template>
  <div v-loading.body="loading">
    <el-row class="filter">
      <el-col>
        <div
          style="
            background: #f3f3f3;
            height: 30px;
            line-height: 30px;
            padding: 0 25px;
            display: flex;
            align-items: center;
          "
        >
          <div>筛选查询</div>
          <el-button
            type="text"
            style="margin-left: auto"
            :icon="filterFold ? 'el-icon-arrow-down' : 'el-icon-arrow-up'"
            @click="toggleFilter"
            >{{ filterFold ? "展开筛选" : "收起筛选" }}</el-button
          >
        </div>
        <el-collapse-transition>
          <div v-show="!filterFold">
            <div style="padding: 10px 25px">
              <el-col :span="24">
                <el-form :inline="true" :model="form" class="demo-form-inline">
                  <el-form-item label="">
                    <el-select
                      v-model="form.father_market_id"
                      filterable
                      placeholder="市场"
                      @change="setChild"
                    >
                      <el-option
                        v-for="item in market"
                        :key="item.key"
                        :label="item.label"
                        :value="item.key"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="">
                    <el-select
                      v-model="form.market_id"
                      filterable
                      placeholder="子市场"
                    >
                      <el-option
                        v-for="item in child_market"
                        :key="item.key"
                        :label="item.label"
                        :value="item.key"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item>
                    <el-input
                      v-model="form.supply_name"
                      placeholder="商家名称"
                      @keyup.native.enter="search"
                    ></el-input>
                  </el-form-item>
                  <el-form-item>
                    <el-input
                      v-model="form.goods_no"
                      placeholder="货号"
                      @keyup.native.enter="search"
                    ></el-input>
                  </el-form-item>
                  <el-form-item>
                    <el-input
                      v-model="form.goods_kh"
                      placeholder="款号"
                      @keyup.native.enter="search"
                    ></el-input>
                  </el-form-item>
                  <el-form-item>
                    <el-input
                      v-model="form.sku"
                      placeholder="SKU编号"
                      @keyup.native.enter="search"
                    ></el-input>
                  </el-form-item>
                  <el-form-item label="">
                    <el-select
                      v-model="form.pgid"
                      filterable
                      placeholder="代采组"
                    >
                      <el-option
                        v-for="item in pg_list"
                        :key="item.pgid"
                        :label="item.pgname"
                        :value="item.pgid"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="">
                    <el-select
                      v-model="form.pg_member_id"
                      filterable
                      placeholder="代采员"
                    >
                      <el-option label="全部" value=""></el-option>
                      <el-option label="(空)" value="0"></el-option>
                      <el-option
                        v-for="item in memberOption"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="">
                    <el-select
                      v-model="form.dgid"
                      filterable
                      placeholder="次品组"
                    >
                      <el-option label="全部" value=""></el-option>
                      <el-option
                        v-for="item in defectiveGroupOption"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="">
                    <el-select
                      v-model="form.dg_member_id"
                      filterable
                      placeholder="次品员"
                    >
                      <el-option label="全部" value=""></el-option>
                      <el-option
                        v-for="item in defectiveGroupMemberOption"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="">
                    <el-select
                      v-model="form.refund_member_id"
                      filterable
                      placeholder="售后退供员"
                    >
                      <el-option label="全部" value=""></el-option>
                      <el-option
                        v-for="item in refundMemberOption"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item>
                    <el-select
                      v-model="form.source"
                      multiple
                      placeholder="来源"
                    >
                      <el-option
                        v-for="item in source"
                        :key="item.key"
                        :label="item.label"
                        :value="item.key"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item>
                    <el-select v-model="form.rd_status" placeholder="接收状态">
                      <el-option label="全部" value="0"></el-option>
                      <el-option
                        v-for="item in rd_status"
                        :key="item.key"
                        :label="item.label"
                        :value="item.key"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item>
                    <el-select
                      v-model="form.blp_type"
                      placeholder="不良品类型"
                      multiple
                    >
                      <el-option
                        v-for="item in blpTypeOption"
                        :key="item.key"
                        :label="item.label"
                        :value="item.key"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item>
                    <el-select
                      v-model="form.out_machine"
                      placeholder="出库设备"
                      multiple
                    >
                      <el-option
                        v-for="(item, key) in outMachineOption"
                        :key="key"
                        :label="item"
                        :value="key"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="出库时间：">
                    <el-date-picker
                      v-model="form.out_time"
                      :default-time="['00:00:00', '23:59:59']"
                      type="datetimerange"
                      value-format="yyyy-MM-dd HH:mm:ss"
                      range-separator="至"
                      start-placeholder="开始日期"
                      end-placeholder="结束日期"
                    >
                    </el-date-picker>
                  </el-form-item>
                  <el-form-item label="次品接收时间：">
                    <el-date-picker
                      v-model="form.rd_time"
                      :default-time="['00:00:00', '23:59:59']"
                      type="datetimerange"
                      value-format="yyyy-MM-dd HH:mm:ss"
                      range-separator="至"
                      start-placeholder="开始日期"
                      end-placeholder="结束日期"
                    >
                    </el-date-picker>
                  </el-form-item>
                  <el-form-item label="包裹单号：">
                    <el-input
                      v-model="form.ex_package_no"
                      placeholder="请输入包裹单号"
                      clearable
                    ></el-input>
                  </el-form-item>
                  <el-form-item>
                    <el-button type="primary" @click="search">查询</el-button>
                  </el-form-item>
                </el-form>
              </el-col>
            </div>
          </div>
        </el-collapse-transition>
      </el-col>
    </el-row>

    <!-- 表格 -->
    <el-row v-if="!loading">
      <el-col style="border: 1px solid #ddd">
        <el-row
          :span="24"
          style="
            background: #f3f3f3;
            height: 50px;
            line-height: 30px;
            padding: 0 25px;
            display: flex;
            align-items: center;
          "
        >
          <el-col :span="8">数据列表：</el-col>
          <el-col :span="16" style="text-align: right">
            <el-button
              type="primary"
              size="mini"
              @click="exchangeOutCreateReject"
              >退换货接收</el-button
            >
            <el-button type="success" size="mini" @click="output">
              导出</el-button
            >
          </el-col>
        </el-row>
        <div v-if="resData" style="margin-bottom: 0">
          <el-table
            ref="multipleTable"
            v-loading="tableLoading"
            height="600"
            :data="resData.list"
            tooltip-effect="dark"
            style="width: 100%"
            @selection-change="handleSelectionChange"
          >
            <el-table-column
              type="selection"
              width="50"
              align="center"
              :selectable="checkboxInit"
            ></el-table-column>
            <el-table-column label="图片" align="center">
              <template #default="scope">
                <img
                  :src="scope.row.middle_img[0]"
                  alt=""
                  style="max-width: 80px; max-height: 80px"
                  @click="
                    preview = true;
                    imgs = scope.row.middle_img;
                  "
                />
              </template>
            </el-table-column>
            <el-table-column
              prop="supply_city"
              label="城市"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="market_name"
              label="市场"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="supply_name"
              label="商家"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="brand_name"
              label="品牌"
              align="center"
            ></el-table-column>
            <el-table-column prop="" label="商品状态" align="center">
              <template #default="scope">
                {{ scope.row.goods_lib_goods_status }}/{{
                  scope.row.goods_lib_is_on_sale
                }}
              </template>
            </el-table-column>
            <el-table-column
              prop="cat_name"
              label="商品分类"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="goods_name"
              label="商品名称"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="dbid"
              label="打标ID"
              align="center"
            ></el-table-column>
            <el-table-column prop="" label="货号/颜色/尺码" align="center">
              <template #default="scope">
                {{ scope.row.goods_no }}/{{ scope.row.co_val }}/{{
                  scope.row.si_val
                }}
              </template>
            </el-table-column>
            <el-table-column
              prop="sku"
              label="SKU编码"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="source"
              label="来源"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="blp_type"
              label="不良品类型"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="blp_note"
              label="不良品备注"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="pgname"
              label="代采组"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="pgm_admin"
              label="代采员"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="group_name"
              label="次品组"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="dgm_admin"
              label="次品员"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="refund_member_name"
              label="售后退供员"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="out_machine_text"
              label="出库设备"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="out_time"
              label="出库时间"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="out_admin"
              label="出库人"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="operator_time"
              label="打包时间"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="operator_admin_name"
              label="打包人"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="ex_package_no"
              label="包裹单号"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="desk_no"
              label="打包工作台"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="rd_time"
              label="次品接收时间"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="rd_admin"
              label="次品接收人"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="deliver_time"
              label="包裹妥投时间"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="deliver_admin_name"
              label="妥投人"
              align="center"
            ></el-table-column>
            <el-table-column prop="deliver_img" label="妥投图" align="center">
              <template #default="{ row }">
                <img
                  v-if="row.deliver_img"
                  :src="row.deliver_img"
                  alt=""
                  style="max-width: 80px; max-height: 80px"
                  @click="handleViewImages([row.deliver_img])"
                />
              </template>
            </el-table-column>
            <el-table-column
              prop="fevr_supply_signing_time"
              label="商家签收时间"
              align="center"
            ></el-table-column>
          </el-table>
        </div>
        <div v-if="resData" style="text-align: right; padding: 25px">
          <el-pagination
            :current-page.sync="curPage"
            background
            layout="total, prev, pager, next, jumper ,sizes"
            :total="resData.count"
            :page-size="form.pagesize"
            :page-sizes="[50, 100, 200, 500]"
            @current-change="handleCurrentChange"
            @size-change="handleSizeChange"
          >
          </el-pagination>
        </div>
      </el-col>
    </el-row>
    <preview-image
      :show="preview"
      :imgs="imgs"
      @closeBox="preview = false"
    ></preview-image>
  </div>
</template>

<script>
import apiBaseURL from "@/utils/baseUrl.js";
import previewImage from "../../components/PreviewImage.vue";

export default {
  components: { previewImage },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.fetchCondition();
    });
  },
  data() {
    return {
      resData: {
        setting: "未配置数据",
      },
      form: {
        out_time: this.searchDate(),
        pagesize: 50,
        page: 1,
        dbids: [],
        market_id: "",
        blp_type: [],
        source: [1, 2],
        ex_package_no: "",
      },
      loading: false,
      url: "/erp/StockInRecord/getExchangeList",
      curPage: 1,
      tableLoading: false,
      filterFold: false,
      msg: "",
      search_ops: [],
      imgs: [],
      preview: false,
      memberOption: [],
      defectiveGroupOption: [],
      defectiveGroupMemberOption: [],
      refundMemberOption: [],
      blpTypeOption: [],
      outMachineOption: [],
      market: [],
      child_market: [],
      floor: [],
      pg_list: [],
      source: [
        { label: "常规", key: 1 },
        { label: "售后", key: 2 },
        { label: "售后(售后退供)", key: 3 },
      ],
      rd_status: [
        { label: "已接收", key: 1 },
        { label: "未接收", key: 2 },
      ],
    };
  },
  computed: {
    filteredForm() {
      for (const key in this.form) {
        if (
          this.form[key] === undefined ||
          this.form[key] === "" ||
          this.form[key] === null
        ) {
          delete this.form[key];
        }
      }
      return this.form;
    },
  },

  // created() {
  //     this.fetchData()
  // },
  methods: {
    setChild(value) {
      this.$set(this.form, "market_id", "0");

      Object.keys(this.market).forEach((key) => {
        if (value == this.market[key].key) {
          this.child_market = this.market[key].children;
        }
      });
    },
    exchangeOutCreateReject() {
      if (this.form.dbids.length == 0) {
        this.$message.error("请选择要接收的数据.");
        return;
      }
      const msg = `退货或接收:共${this.form.dbids.length}件`;
      this.$confirm(msg, "", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$http
            .post("/erp/StockInRecord/exchangeOutCreateReject", {
              dbids: this.form.dbids,
            })
            .then((rs) => {
              if (rs.data.code != 200) {
                this.$message.error(rs.data.msg);
                return;
              }
              this.$message.success(rs.data.msg);
              this.fetchData(true);
            });
        })
        .catch(() => {});
    },
    checkboxInit(row) {
      if (row.reject_detail_id != 0) return 0;
      // 不可勾选
      return 1; // 可勾选
    },
    handleSelectionChange(val) {
      const multipleSelection = [];
      Object.keys(val).forEach((key) => {
        multipleSelection[key] = val[key].dbid;
      });
      this.form.dbids = multipleSelection;
    },
    handleSizeChange($val) {
      this.form.pagesize = $val;
      this.fetchData(true);
    },
    toggleFilter() {
      this.filterFold = !this.filterFold;
    },
    searchDate() {
      const endDate = new Date();
      endDate.setDate(endDate.getDate() + 1);
      const endM =
        endDate.getMonth() + 1 < 10
          ? `0${endDate.getMonth() + 1}`
          : endDate.getMonth() + 1;
      const end = `${endDate.getFullYear()}-${endM}-${endDate.getDate()} 23:59:59`;

      const startDate = new Date();
      startDate.setDate(startDate.getDate());
      const startM =
        startDate.getMonth() + 1 < 10
          ? `0${startDate.getMonth() + 1}`
          : startDate.getMonth() + 1;
      const start = `${startDate.getFullYear()}-${startM}-${startDate.getDate()} 00:00:00`;
      return [start, end];
    },

    output() {
      this.form.is_excel = 1;
      this.loading = true;
      this.$http.post(this.url, this.filteredForm).then((res) => {
        this.form.is_excel = 0;
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.loading = false;
          if (res.data.code !== 200) {
            this.$message.error(res.data.msg);
          } else {
            window.open(apiBaseURL + res.data.data.file);
          }
        }
      });
    },

    handleCurrentChange(val) {
      this.form.page = val;
      this.fetchData(true);
    },
    search() {
      this.form.page = 1;
      this.form.is_excel = 0;
      this.fetchData(true);
    },
    fetchData(showLoading) {
      this.form.dbids = [];
      if (showLoading) {
        this.loading = true;
      }
      this.$http.post(this.url, this.filteredForm).then((res) => {
        this.loading = false;
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.resData = res.data.data;
        }
      });
    },
    fetchCondition() {
      this.$http.post(this.url, { condition: 1 }).then((res) => {
        this.loading = false;
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.resData = res.data.data;
          this.market = this.resData.market;
          this.child_market = this.resData.child_market;
          this.pg_list = this.resData.pg_list;
          this.memberOption = res.data.data.memberOption;
          this.defectiveGroupOption = res.data.data.defectiveGroupOption;
          this.defectiveGroupMemberOption =
            res.data.data.defectiveGroupMemberOption;
          this.refundMemberOption = res.data.data.refundMemberOption;
          this.blpTypeOption = res.data.data.blpTypeOption;
          this.outMachineOption = res.data.data.outMachineOption;
        }
      });
    },
    reset() {
      this.form = {
        recheck_begin_time: this.searchDate(),
        page: 1,
        pagesize: 50,
        search_type: 1,
      };
    },
    handleViewImages(images) {
      this.$viewerApi({
        images,
      });
    },
  },
};
</script>

<style scoped>
.row {
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  font-size: 12px;
}

.column {
  text-align: center;
  border: 1px solid #ddd;
  font-size: 12px;
}

.data-statics {
  background: #f3f3f3;
  height: 40px;
  font-size: 14px;
  color: #333;
  line-height: 40px;
  padding: 0 25px;
}

.filter {
  border: 1px solid #ddd;
}

.tab-div {
  border: 1px solid #ddd;
  margin: 20px 0;
  padding: 10px 0 10px 20px;
}

.tag-css {
  margin-left: 10px;
}

.el-row {
  margin-bottom: 20px;
}

.el-row:last-child {
  margin-bottom: 0;
}

.el-dropdown-menu__item {
  background-color: #f56c6c;
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/pages/stocking/ExchangeList.vue